import { getExperimentPropertiesForEventPayload } from './../lib/platform/getExperimentPropertiesForEventPayload';

//
// Segment analytics event tracking that includes experiment data.
//
// https://segment.com/docs/libraries/analytics.js/
//
export default function trackEvent (event, params={}) {
    params = { url: window.location.href, ...params };

    params = {
        ...getExperimentPropertiesForEventPayload(),
        ...params
    };


    if (__DEV__) {
        console.info('Track event: "%s": %o', event, params); // eslint-disable-line no-console
    }

    if (window.analytics) {
        window.analytics.track(event, params);
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/platform/trackEvent.js